export default "__VITE_ASSET__SXT7SMm9__"